import { apiConnector } from "../apiconnector";
import toast from "react-hot-toast";
import { adminEndpoints } from "../apis";

// Send an invite to an employee
export const createEmployeeInvite = async (data, token) => {
  try {
    const response = await apiConnector(
      "POST",
      adminEndpoints.CREATE_EMPLOYEE_INVITE_API,
      data,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Employee invite sent");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to send invite");
    throw err;
  }
};


// Delete admin account
export const deleteAdminAccount = async (token) => {
  try {
    const response = await apiConnector(
      "DELETE",
      adminEndpoints.DELETE_ADMIN_ACCOUNT_API,
      null,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Admin account deleted");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to delete admin account");
    throw err;
  }
};

// Remove an employee from the team
export const removeEmployee = async (employeeId, token) => {
  try {
    const response = await apiConnector(
      "DELETE",
      adminEndpoints.REMOVE_EMPLOYEE_API(employeeId),
      null,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Employee removed successfully");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to remove employee");
    throw err;
  }
};




// Get invited employees
export const getInvitedEmployees = async (token) => {
  try {
    const response = await apiConnector(
      "GET",
      adminEndpoints.GET_INVITED_EMPLOYEES_API,
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch invited employees");
    throw err;
  }
};



